import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"currentColor\" id=\"icon-edit\">\n  <path d=\"M15.609,4.905l-0.514-0.514c-0.521-0.521-1.365-0.521-1.886,0l-0.471,0.471l2.4,2.4l0.471-0.471 C16.13,6.27,16.13,5.426,15.609,4.905z\" />\n  <path d=\"M5.219,12.381L4,16l3.619-1.219l0,0l7.048-7.047l-2.4-2.4L5.219,12.381z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol